<template>
  <div>
    <div class="sidebar__head">
      <h5>Shopping Cart</h5>
    </div>
    <!-- /.sidebar__head -->
    <div class="sidebar__content">
      <div class="table">
        <table
          style="table-layout: fixed"
          v-bind:class="{ 'table-mobile': isMobile }"
        >
          <thead>
            <tr>
              <th style="width: 10%">Qty</th>
              <th class="text-left" style="width: 55%">Description</th>
              <th class="text-left" style="width: 20%">Cost</th>
              <th style="width: 15%"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="filtered_list.length">
              <td>{{ filtered_list.length }}</td>
              <td class="text-left">{{ $gift_word }} to Members</td>
              <!-- <td class="text-left" >Greetings to Members</td> -->

              <td class="text-left">
                {{ membersPrice | currency(settings[0].symbol) }}
              </td>
              <td></td>
            </tr>
            <tr v-if="cart.additionalBaskets.length">
              <td>{{ cart.additionalBaskets.length }}</td>
              <td class="text-left">Gift Baskets to be Shipped</td>
              <td class="text-left">
                {{ basketPrice | currency(settings[0].symbol) }}
              </td>
              <td></td>
            </tr>
          </tbody>
          <tbody v-for="item in cart.orderItems" :key="item.orderItemId">
            <tr>
              <td>{{ item.quantity }}</td>
              <td class="text-left">{{ item.description }}</td>
              <td
                class="text-left"
                v-if="
                  item.itemId !== 1 && item.itemId !== 29 && item.itemId !== 30
                "
              >
                {{
                  (item.price * item.quantity) | currency(settings[0].symbol)
                }}
              </td>
              <td
                class="text-left"
                v-if="
                  item.itemId == 1 || item.itemId == 29 || item.itemId == 30
                "
              >
                {{
                  (item.price * item.quantity) | currency(settings[0].symbol)
                }}
              </td>
              <td>
                <a
                  @click="togglePpl = !togglePpl"
                  style="color: #448aff !important; padding-right: 15px"
                  v-if="promoIDs.indexOf(item.itemId) > -1"
                  ><i class="fas fa-eye"></i></a
                ><a
                  @click="deleteOrderItem(item)"
                  style="color: red !important"
                  v-if="
                    item.itemId !== -120 &&
                      item.description !== 'Admin Fee' &&
                      item.itemId !== -995 &&
                      item.itemId !== -993 &&
                      customOptions.disableDelete.indexOf(item.itemId) === -1
                  "
                  ><i class="fas fa-times"></i
                ></a>
              </td>
            </tr>
            <!-- <span v-if="togglePpl">
            <tr v-for="sub in item.promodata" :key="sub.id" ><td colspan="5" class="text-left" style="padding: 0.5em 0.75rem">{{ sub.title }} {{ sub.lastName }} {{ sub.firstName }}
                {{ sub.sFirstName }}</td></tr>
                </span> -->
            <tr
              v-for="(sub, index) in getPromoPeople(item)"
              :key="sub.id"
              v-if="togglePpl"
            >
              <td
                style="padding: 0.5em 0.75rem; color: #8a8a8a; font-size: 11px"
              >
                <span>{{ index + 1 }}.</span>
              </td>
              <td
                colspan="3"
                class="text-left"
                style="padding: 0.5em 0.75rem; color: #8a8a8a; font-size: 11px"
              >
                <span
                  v-if="
                    custom.displayTitles.indexOf(settings[0].organizationId) ===
                      -1
                  "
                  >{{ sub.lastName }} {{ sub.firstName }}
                  <span v-if="sub.sFirstName !== ''">&</span>
                  {{ sub.sFirstName }}
                  <span v-if="sub.sLastName !== sub.lastName">
                    {{ sub.sLastName }}</span
                  >
                </span>
                <span
                  v-if="
                    custom.displayTitles.indexOf(settings[0].organizationId) >
                      -1 && sub.sFirstName
                  "
                  >{{ sub.lastName }} {{ sub.firstName }}
                  <span v-if="sub.title !== ''">{{ sub.title }}</span>
                  {{ sub.sFirstName }}
                  <span v-if="sub.sLastName !== sub.lastName">
                    {{ sub.sLastName }}</span
                  ></span
                >
                <span
                  v-if="
                    custom.displayTitles.indexOf(settings[0].organizationId) >
                      -1 && !sub.sFirstName
                  "
                >
                  <span v-if="sub.title !== ''">{{ sub.title }}</span>
                  {{ sub.lastName }} {{ sub.firstName }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- /.table -->
      <!-- Memebers outside of memberslits selected -->
      <div
        class="sidebar__box d-flex justify-content-between align-items-center"
        v-if="cart.additionalBaskets.length"
      >
        <!--* custom baskets in cart --->
        <a @click="showBaskets = !showBaskets">
          <span style="padding-right: 2em"
            >Gift Baskets to be Shipped ({{
              cart.additionalBaskets.length
            }})</span
          >
          <i class="fas fa-caret-down"></i>
          <!-- <i class="ico-arrow-down-white"></i>
           -->
        </a>
      </div>
      <div class="member-wrap md-scrollbar" v-if="showBaskets">
        <div class="table">
          <table style="table-layout: fixed">
            <tbody
              v-for="item in cart.additionalBaskets"
              :key="item.shippingItemId"
            >
              <tr>
                <td class="text-left b-t-pink">
                  <div class="item-recipient-container">
                    <p>{{ item.recipient }}</p>
                    <p>{{ getShippingDescription(item.shippingOptionId) }}</p>
                    <p v-if="item.attributes && calculateAttributes(item)">
                      Customization ${{
                        convertWithCommas(calculateAttributes(item))
                      }}
                    </p>
                  </div>
                </td>
                <td class="w-70 b-t-pink">
                  <a @click="editBasket(item)"><i class="fad fa-edit"></i></a>
                </td>
                <td class="w-70 b-t-pink">
                  <a @click="openPrompt(item)"><i class="fas fa-times"></i></a>
                </td>
              </tr>
              <tr>
                <td
                  class="text-left basket-message"
                  v-bind:title="item.message"
                  colspan="3"
                  v-if="item.message"
                >
                  <label> Message:</label>
                  {{ item.message }}
                </td>
              </tr>
              <tr>
                <td class="text-left basket-message" colspan="3">
                  <label> Address:</label>
                  {{ item.address }} {{ item.address2 }},{{ item.city }},
                  {{ item.state }} {{ item.zip }}
                </td>
              </tr>
              <!-- customization for basket here -->
              <tr v-if="getItemCustomizations(item).length">
                <td
                  class="text-left basket-message"
                  colspan="3"
                  style="padding-left: 30px;"
                >
                  <label> Customization:</label>
                  <ul>
                    <li
                      v-for="(cus, i) in getItemCustomizations(item)"
                      :key="i"
                    >
                      <b>{{ cus.promptText }}:</b> {{ cus.value }} - (${{
                        convertWithCommas(cus.price)
                      }})
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--  My Mishaloach Manot Selected Member List -->
      <div
        class="sidebar__box d-flex justify-content-between align-items-center"
        v-if="profile[0] && profile[0].reciprocity"
        style="color: black; text-align: left; background-color: #eff2ff"
      >
        <p>
          Note: YOU HAVE SELECTED RECIPROCITY: By selecting reciprocity you are
          authorizing us to charge you for each and every basket that is sent on
          your behalf. You may receive from more people than you anticipate, and
          will thus send to more people than you expect.
        </p>
      </div>
      <div
        class="sidebar__box d-flex justify-content-between align-items-center"
        v-if="filtered_list.length"
      >
        <a @click="toggle = !toggle">
          <span style="padding-right: 2em"
            >View Individual Selections ({{ filtered_list.length }})</span
          >
          <i class="fas fa-caret-down"></i>
          <!-- <i class="ico-arrow-down-white"></i>
           -->
        </a>
      </div>
      <div class="member-wrap md-scrollbar" v-if="toggle">
        <div class="table">
          <table style="table-layout: fixed">
            <tbody>
              <tr v-for="item in filtered_list" :key="item.id">
                <td class="text-left">
                  <span></span>
                  <span
                    v-if="
                      custom.displayTitles.indexOf(
                        settings[0].organizationId,
                      ) === -1
                    "
                    >{{ item.lastName }} {{ item.firstName }}
                    <span v-if="item.sFirstName !== ''">&</span>
                    {{ item.sFirstName }}
                    <span v-if="item.sLastName !== item.lastName">
                      {{ item.sLastName }}</span
                    >
                  </span>
                  <span
                    v-if="
                      custom.displayTitles.indexOf(settings[0].organizationId) >
                        -1 && item.sFirstName
                    "
                    >{{ item.lastName }} {{ item.firstName }}
                    <span v-if="item.title !== ''">{{ item.title }}</span>
                    {{ item.sFirstName }}
                    <span v-if="item.sLastName !== item.lastName">
                      {{ item.sLastName }}</span
                    ></span
                  >
                  <span
                    v-if="
                      custom.displayTitles.indexOf(settings[0].organizationId) >
                        -1 && !item.sFirstName
                    "
                  >
                    <span v-if="item.title !== ''">{{ item.title }}</span>
                    {{ item.lastName }} {{ item.firstName }}
                  </span>
                  <span
                    style="font-weight: 600"
                    v-if="organizationInfo.id == 647"
                  >
                    {{ item.price | currency(settings[0].symbol) }}</span
                  >
                  <span
                    style="font-weight: 600"
                    v-if="organizationInfo.id !== 647 && item.price > 0"
                  >
                    {{ item.price | currency(settings[0].symbol) }}</span
                  >
                </td>
                <td class="w-70">
                  <a @click="deleteMember(item)" title="Remove Member"
                    ><i class="fas fa-times"> </i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- /.sidebar__box -->
    </div>
    <!-- /.sidebar__content -->
    <!-- if discounts available -->
    <div class="sidebar__foot" v-if="discounts.length">
      <div class="d-flex justify-content-between align-items-center">
        <p>Total</p>
        <span class="blue"
          >{{ totalPrice | currency(settings[0].symbol) }}
        </span>
      </div>
      <div
        class="d-flex justify-content-between align-items-center m-t-1 m-b-1"
      >
        <p style="text-align: left">
          {{ discounts[0].description }}
          <i class="fas fa-question-circle"></i>
          <md-tooltip md-direction="top" class="info-tooltip">
            <span v-if="discounts[0].excludeCharity"
              >Donations To Charity are excluded from discounted price</span
            >
            <span v-if="!discounts[0].excludeCharity"
              >Donations To Charity are included in discounted price</span
            >
          </md-tooltip>
        </p>
        <span class="blue">-{{ disc | currency(settings[0].symbol) }}</span>
      </div>
      <div
        class="d-flex justify-content-between align-items-center fee"
        v-if="
          settings[0].feeRequired &&
            settings[0].feeActive &&
            totalDiscountedPrice > 0
        "
      >
        <p class="pink">{{ settings[0].feeDesc }}</p>
        <span class="blue pink"
          >{{
            (processFee + settings[0].perTransactionFee)
              | currency(settings[0].symbol)
          }}
        </span>
      </div>
      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          m-t-1
          total-wrap
        "
      >
        <p style="color: #cc0505">Order Total</p>
        <!-- if fees are not active -->
        <span
          class="blue"
          style="color: #cc0505"
          v-if="!settings[0].feeRequired && !settings[0].feeActive"
          >{{ totalDiscountedPrice | currency(settings[0].symbol) }}</span
        >
        <span
          class="blue"
          style="color: #cc0505"
          v-if="
            settings[0].feeRequired &&
              settings[0].feeActive &&
              totalDiscountedPrice <= 0
          "
        >
          {{ totalDiscountedPrice | currency(settings[0].symbol) }}</span
        >
        <span
          class="blue"
          style="color: #cc0505"
          v-if="
            settings[0].feeRequired &&
              settings[0].feeActive &&
              totalDiscountedPrice > 0
          "
        >
          {{
            (totalDiscountedPrice + processFee + settings[0].perTransactionFee)
              | currency(settings[0].symbol)
          }}</span
        >
        <span class="blue" style="color: #cc0505" v-else>
          {{ totalDiscountedPrice | currency(settings[0].symbol) }}</span
        >
      </div>
    </div>
    <!-- if NOT discounts available  FEE -->
    <div class="sidebar__foot" v-if="!discounts.length">
      <div
        class="d-flex justify-content-between align-items-center fee"
        v-if="
          settings[0].feeRequired && settings[0].feeActive && totalPrice > 0
        "
      >
        <p class="pink">{{ settings[0].feeDesc }}</p>
        <span class="blue pink"
          >{{
            (processFee + settings[0].perTransactionFee)
              | currency(settings[0].symbol)
          }}
        </span>
      </div>
      <!-- Order Total -->
      <div
        class="d-flex justify-content-between align-items-center p-t-1"
        v-if="settings[0].feeRequired && settings[0].feeActive"
      >
        <p>Order Total</p>

        <span class="blue" v-if="totalPrice <= 0"
          >{{ totalPrice | currency(settings[0].symbol) }}
        </span>
        <span class="blue" v-if="totalPrice > 0">
          {{
            (totalPrice + processFee + settings[0].perTransactionFee)
              | currency(settings[0].symbol)
          }}
        </span>
      </div>
      <!-- Order Total -->
      <div
        class="d-flex justify-content-between align-items-center p-t-1"
        v-if="!settings[0].feeRequired"
      >
        <p>Order Total</p>
        <span class="blue"
          >{{ totalPrice | currency(settings[0].symbol) }}
        </span>
      </div>
    </div>
    <!-- /.sidebar__foot -->
    <!--MODAL DIALOG  EDIT BASKET-->
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title>Edit Gift Basket</md-dialog-title>
      <md-dialog-content>
        <div class="box__content">
          <div class="form-frame form-frame--alt">
            <div class="form-row">
              <div class="form-group col-lg-12">
                <label for="field-fname" class="form__label"> Recipient </label>
                <input
                  type="text"
                  class="field"
                  id="field-fname"
                  placeholder
                  v-model="additionalSelBasket.recipient"
                />
              </div>
              <!-- /.form-group -->
              <!-- <div class="form-group col-lg-6">
                <label for="field-lname" class="form__label">
                  Recipient Last Name
                </label>
                <input
                  type="text"
                  class="field"
                  id="field-lname"
                  placeholder
                  v-model="additionalSelBasket.lastName1"
                />
              </div> -->
              <!-- /.form-group -->
            </div>
            <!-- /.form-row -->
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="field-address-3" class="form__label"
                  >Address1</label
                >
                <input
                  type="text"
                  class="field"
                  id="field-address-3"
                  placeholder
                  v-model="additionalSelBasket.address"
                />
              </div>
              <!-- /.form-group -->
            </div>
            <!-- /.form-row -->
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="field-address-4" class="form__label"
                  >Address2</label
                >
                <input
                  type="text"
                  class="field"
                  id="field-address-4"
                  placeholder
                  v-model="additionalSelBasket.address2"
                />
              </div>
              <!-- /.form-group -->
            </div>
            <!-- /.form-row -->
            <div class="form-row">
              <div class="form-group col-lg-6">
                <label for="field-city-2" class="form__label">City</label>
                <input
                  type="text"
                  class="field"
                  id="field-city-2"
                  placeholder
                  v-model="additionalSelBasket.city"
                />
              </div>
              <!-- /.form-group col-md-6 -->
              <div class="form-group col-lg-2 col-md-6">
                <label for="field-state-2" class="form__label">State</label>
                <input
                  type="text"
                  id="field-state-2"
                  v-model="additionalSelBasket.state"
                  class="field"
                />
                <!-- <div class="select select--grey">
                  <select
                    id="field-state-2"
                    v-model="additionalSelBasket.state"
                  >
                    <option value>Select</option>
                    <option value="NY">NY</option>
                    <option value="FL">FL</option>
                  </select>
                </div> -->
                <!-- /.select -->
              </div>
              <!-- /.form-group col-md-2 -->
              <div class="form-group col-lg-4 col-md-6">
                <label for="field-code-2" class="form__label">
                  Postal Code
                </label>
                <input
                  type="text"
                  class="field"
                  id="field-code-2"
                  placeholder
                  v-model="additionalSelBasket.zip"
                />
              </div>
              <!-- /.form-group -->
            </div>
            <!-- /.form-row -->
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="field-phone-2" class="form__label">Phone</label>
                <input
                  type="number"
                  class="field"
                  id="field-phone-2"
                  placeholder
                  v-model="additionalSelBasket.phone"
                />
              </div>
              <!-- /.form-group -->
              <div class="form-group col-md-6">
                <label for="field-phone-3" class="form__label">Email</label>
                <input
                  type="email"
                  class="field"
                  id="field-phone-3"
                  placeholder
                  v-model="additionalSelBasket.email"
                />
              </div>
              <!-- /.form-group -->
            </div>
            <!-- /.form-row -->
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="field-message" class="form__label">Message</label>
                <textarea
                  name="field-message"
                  id="field-message"
                  cols="30"
                  class="field"
                  rows="2"
                  v-model="additionalSelBasket.message"
                ></textarea>
              </div>
              <!-- /.form-group col-md-12 -->
            </div>

            <div class="form-row">
              <!-- <div class="form-group col-md-12"> -->
              <!-- <md-checkbox v-model="additionalBasket.glutenFree" >Gluten Free</md-checkbox> -->
              <!-- @change="changeBasketPrice(item.price)" -->
              <!-- <md-radio
                  v-model="additionalSelBasket.shippingOptionId"
                  :value="item.id"
                  v-for="item in $store.state.shippingCustomOptions"
                  :key="item.id"
                >
                  <span
                    v-if="
                      item.description !== 'Regular Baskets' &&
                        item.description !== 'Premium Baskets'
                    "
                    >{{ item.description }}
                  </span>
                  <span v-if="item.description === 'Regular Baskets'"
                    >Regular</span
                  >
                  <span v-if="item.description === 'Premium Baskets'"
                    >Premium</span
                  ></md-radio
                > -->
              <div
                :class="{
                  'selected-custom-basket':
                    additionalSelBasket.shippingOptionId === item.id,
                }"
                class="custom-basket col-6 col-md-3"
                v-for="(item, index) in $store.state.shippingCustomOptions"
                :key="item.id"
              >
                <BasketImg
                  :item="item"
                  :index="index"
                  @onSelectedBasket="onSelectedCustomBasket"
                ></BasketImg>
                <span
                  v-if="
                    item.description !== 'Regular Baskets' &&
                      item.description !== 'Premium Baskets'
                  "
                  >{{ item.description }}
                </span>
                <span v-if="item.description === 'Regular Baskets'"
                  >Regular</span
                >
                <span v-if="item.description === 'Premium Baskets'"
                  >Premium</span
                >
                <!-- <md-radio
                            v-model="selCustomOption"
                            :value="item.id"
                            @change="changeBasketPrice(item.price)"
                          >
                            <span
                              v-if="
                                item.description !== 'Regular Baskets' &&
                                  item.description !== 'Premium Baskets'
                              "
                              >{{ item.description }}
                            </span>
                            <span v-if="item.description === 'Regular Baskets'"
                              >Regular</span
                            >
                            <span v-if="item.description === 'Premium Baskets'"
                              >Premium</span
                            ></md-radio
                          > -->
              </div>

              <!-- </div> -->
            </div>

            <!--* ATTRIBUTES --->
            <template
              v-if="
                selCustomOptionBasketItem &&
                  selCustomOptionBasketItem.hasAttributes
              "
            >
              <hr />
              <p class="personalization-p">Basket Personalization</p>
              <div
                v-for="(item, index) in basketAttributes"
                :key="index"
                class="form-row row mt-2 mb-2"
              >
                <p class="col-12" style="color: var(--app-color-primary);">
                  {{ index + 1 }}: {{ item.name }}
                </p>
                <div
                  class="col-12 col-md-6"
                  style="display: flex; flex-direction: column;"
                >
                  <div class="mb-2">
                    <p
                      style="cursor: pointer; margin: 0;display: flex; align-items: center;"
                    >
                      <md-checkbox
                        v-model="basketAttributesCheckBoxes[index]"
                        @change="
                          () => {
                            basketAttributes[index].value = undefined;
                          }
                        "
                      >
                        {{ item.description }}:</md-checkbox
                      >
                    </p>
                  </div>

                  <div
                    class="form-group"
                    style="display: flex;     flex-direction: column;"
                  >
                    <label for="field-grogger" class="form__label">
                      {{ item.promptText }}
                    </label>

                    <!--  -->
                    <input
                      :disabled="!basketAttributesCheckBoxes[index]"
                      style="margin-top: 10px; width: 256px"
                      type="text"
                      class="field"
                      v-model="item.value"
                      id="field-grogger"
                      placeholder="enter the text"
                    />
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <img
                    v-if="item.imageURL"
                    style="max-width: 200px;"
                    :src="item.imageURL"
                    alt="no img"
                  />
                </div>
              </div>
              <hr />

              <div style="height: 100px;"></div>
            </template>
            <!--* ATTRIBUTES --->

            <!-- <div class="form-row">
              <div class="form-group col-md-12">
                <md-checkbox v-model="additionalSelBasket.glutenFree"
                  >Gluten Free</md-checkbox
                >
              </div>
            </div> -->
            <!-- /.form-row -->
            <!-- /.form__actions -->
          </div>
          <!-- /.form-checkout -->
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="btn-grey" @click="closeBasket(additionalSelBasket)"
          >Close</md-button
        >
        <md-button class="btn-green" @click="saveBasket(additionalSelBasket)"
          >Save</md-button
        >
      </md-dialog-actions>
    </md-dialog>
    <!-- Prompt If User wants to delete Baskte -->
    <div>
      <md-dialog-confirm
        :md-active.sync="showPrompt"
        md-title="Please Confirm"
        md-content="Are you sure you want to delete Gift Basket?"
        md-confirm-text="Delete"
        md-cancel-text="Cancel"
        @md-cancel="onCancel()"
        @md-confirm="deleteBasket(selItem)"
      />
    </div>
    <!-- fees to cover -->
    <div>
      <md-dialog-confirm
        :md-active.sync="showPromptFees"
        class="prompt_dialog"
        :md-title="settings[0].feeTitle"
        :md-content="feeText"
        md-confirm-text="Add To Order"
        md-cancel-text="No"
        @md-cancel="onCancel()"
        @md-confirm="addFeeToCart()"
      />
    </div>
  </div>
</template>
<script>
import moment from "moment";
import currencyFilter from "../shared/currency-filter";
import { convertWithCommas, showErrorAlert } from "../helpers";
import BasketImg from "../components/BasketImg.vue";

Array.prototype.unique = function() {
  var a = this.concat();
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) a.splice(j--, 1);
    }
  }
  return a;
};
export default {
  name: "CartPage",
  filters: {
    currency: currencyFilter,
  },
  components: { BasketImg },
  data: function() {
    return {
      selCustomOption: null,
      showPromptFees: false,
      toggle: false,
      togglePpl: false,
      showBaskets: true,
      showDialog: false,
      showPrompt: false,
      feeDonation: false,
      selItem: {},
      disc: 0,
      basketLabel: "Gift Baskets to be Shipped",
      basketDecription: "Shipping Gift Basket to",
      additionalSelBasketCopy: {},
      selCustomOptionBasketItem: {},
      additionalSelBasket: {
        address: "",
        address2: "",
        city: "",
        country: "",
        email: "",
        glutenFree: false,
        message: "",
        phoneNumber: "",
        recipient: "",
        firstName1: "",
        lastName1: "",
        shippingItemGuid: "",
        shippingOptionId: "",
        state: "",
        zip: "",
        ApiID: 2,
        Price: 50,
        Qt: 1,
      },
      basketAttributes: [],
      basketAttributesCheckBoxes: [],
      basketAttributesCurrent: [],
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    customOptions() {
      return this.$store.state.customOptions;
    },
    custom() {
      return this.$store.state.custom[0];
    },
    settings() {
      return this.$store.getters.getSettings;
    },
    profile() {
      return this.$store.state.userProfile;
    },
    promoIDs() {
      let obj = [];
      let promos = this.$store.state.promotions;
      for (let i = 0; i < promos.length; i++) {
        if (obj.indexOf(promos[i].itemId) === -1) {
          obj.push(promos[i].itemId);
        }
      }
      return obj;
    },
    filtered_list() {
      let obj = [];
      let list = this.$store.state.list;

      if (this.settings[0].organizationId !== 249) {
        if (this.comboPromotions.length) {
          let ids = [];
          for (let i = 0; i < this.comboPromotions.length; i++) {
            if (
              this.comboPromotions[i].promo.value &&
              !this.comboPromotions[i].promo.paid
            ) {
              ids = ids.concat(this.comboPromotions[i].ids).unique();
            }
          }

          for (let i = 0; i < list.length; i++) {
            if (
              ids.indexOf(list[i].id) === -1 &&
              list[i].selected &&
              !list[i].paid
            ) {
              obj.push(list[i]);
            }
          }
        } else {
          for (var i = 0; i < list.length; i++) {
            if (list[i].selected && !list[i].paid) {
              obj.push(list[i]);
            }
          }
        }
      }
      // MIDWAY JEWISH CENTER EXCEPTION
      else {
        //  if staff promotion is in order items
        let f_order = this.$store.state.cart.orderItems.filter(
          (a) => a.itemId === -994,
        );
        if (f_order.length) {
          let comb = { ids: [], members: [], promo: {} };
          for (let j = 0; j < list.length; j++) {
            if (
              list[j].mCategories.indexOf(1661) > -1 &&
              list[j].selected &&
              !list[j].paid
            ) {
              if (comb.ids.indexOf(list[j].id) === -1) {
                comb.ids.push(list[j].id);
                comb.members.push(list[j]);
                comb.promo = {
                  allCategories: ["1661"],
                  displayText: f_order[0].description,
                  id: 1661,
                  itemId: -994,
                  paid: false,
                  value: true,
                };
              }
            }
          }
          //  add to promotions , so user can have nested view of people under promotion
          this.comboPromotions.push(comb);
          if (this.promoIDs.indexOf(-994) === -1) {
            this.promoIDs.push(-994);
          }
          if (this.comboPromotions.length) {
            let ids = [];
            for (let i = 0; i < this.comboPromotions.length; i++) {
              for (let j = 0; j < this.comboPromotions[i].ids.length; j++) {
                if (obj.indexOf(this.comboPromotions[i].ids[j]) === -1) {
                  ids.push(this.comboPromotions[i].ids[j]);
                }
              }
            }
            for (let i = 0; i < list.length; i++) {
              if (
                ids.indexOf(list[i].id) === -1 &&
                list[i].selected &&
                !list[i].paid
              ) {
                let f_list = obj.filter((a) => a.id === list[i].id);
                if (!f_list.length) {
                  obj.push(list[i]);
                }
              }
            }
          }
          // if no promotions available
        } else {
          // if no staff promotion in checkout
          if (this.comboPromotions.length) {
            let ids = [];
            for (let i = 0; i < this.comboPromotions.length; i++) {
              for (let j = 0; j < this.comboPromotions[i].ids.length; j++) {
                if (obj.indexOf(this.comboPromotions[i].ids[j]) === -1) {
                  ids.push(this.comboPromotions[i].ids[j]);
                }
              }
            }
            for (let i = 0; i < list.length; i++) {
              if (
                ids.indexOf(list[i].id) === -1 &&
                list[i].selected &&
                !list[i].paid
              ) {
                let f_list = obj.filter((a) => a.id === list[i].id);
                if (!f_list.length) {
                  obj.push(list[i]);
                }
              }
            }
          } else {
            for (let z = 0; z < list.length; z++) {
              if (list[z].selected && !list[z].paid) {
                let f_list = obj.filter((a) => a.id === list[z].id);
                if (!f_list.length) {
                  obj.push(list[z]);
                }
              }
            }
          }
        }
      }
      if (this.$store.state.shippingCustomOptions.length) {
        for (let i = 0; i < obj.length; i++) {
          let ship = this.$store.state.shippingCustomOptions.filter(
            (a) => a.description.trim() === obj[i].basketType.trim(),
          );
          if (ship.length) {
            obj[i].price = ship[0].price;
            obj[i].customPrice = ship[0].price;
          }
        }
      }
      return obj;
    },
    discounts() {
      return this.$store.state.discounts;
    },
    membersPrice() {
      let list = this.filtered_list;
      let price = 0;
      let custom_total = this.$store.state.total;

      if (custom_total === 0) {
        if (
          this.organizationInfo.id !== 647 &&
          this.organizationInfo.id !== 249 &&
          this.organizationInfo.id !== 683
        ) {
          price = list.length * this.organizationInfo.sPerperson;
        } else if (this.organizationInfo.id === 647) {
          let arr = [];
          for (let i = 0; i < list.length; i++) {
            arr.push(list[i].customPrice);
          }
          if (arr.length) {
            price = arr.reduce(function(a, b) {
              return a + b;
            });
          }
        } else if (this.organizationInfo.id === 683) {
          let arr = [];
          for (let i = 0; i < list.length; i++) {
            arr.push(list[i].price);
          }
          if (arr.length) {
            price = arr.reduce(function(a, b) {
              return a + b;
            });
          }
        } else if (this.organizationInfo.id == 249) {
          price = 0;
        }
      } else {
        price = custom_total;
      }
      if (
        price > this.organizationInfo.sMaximum &&
        this.organizationInfo.sMaximum !== 0
      ) {
        price = this.organizationInfo.sMaximum;
      }
      this.$store.state.finalOrder.membersPrice = price;

      return price;
    },
    giftBasketPrice() {
      let order = this.$store.state.cart.orderItems;
      let arr = [];
      let sum = 0;
      for (let i = 0; i < order.length; i++) {
        if (
          (order[i].itemId === 1 ||
            order[i].itemId === 30 ||
            order[i].itemId === 29) &&
          order[i].price
        ) {
          sum = order[i].price * order[i].quantity;
        }
      }
      return sum;
    },
    cart() {
      return this.$store.state.cart;
    },
    totalDiscountedPrice() {
      let price = 0;
      if (!this.discounts[0].excludeCharity) {
        this.disc =
          (this.totalPrice * Number(this.discounts[0].discountPercent)) / 100;
        price = this.totalPrice - this.disc;
      } else {
        let arr = [];
        let donations = [];
        let sum = 0;
        let sum_1 = 0;
        let price_1 = 0;
        for (let i = 0; i < this.cart.orderItems.length; i++) {
          if (
            this.cart.orderItems[i].description.indexOf("Donation To Charity") <
            0
          ) {
            arr.push(
              this.cart.orderItems[i].price * this.cart.orderItems[i].quantity,
            );
          } else {
            donations.push(
              this.cart.orderItems[i].price * this.cart.orderItems[i].quantity,
            );
          }
        }
        if (arr.length) {
          sum = arr.reduce(function(a, b) {
            return a + b;
          });
        }
        if (donations.length) {
          sum_1 = donations.reduce(function(a, b) {
            return a + b;
          });
        }
        price_1 = sum + this.membersPrice + this.basketPrice;
        this.disc = (price_1 * Number(this.discounts[0].discountPercent)) / 100;
        this.$store.state.finalOrder.disc = this.disc;
        price = price_1 - this.disc + sum_1;
      }
      this.$store.state.finalOrder.totalDiscountedPrice = price;
      this.$store.state.finalOrder.disc = this.disc;
      return price;
    },
    totalPrice() {
      // return this.$store.getters.getTotalPrice;
      let price = 0;
      let arr = [];
      let sum = 0;
      for (let i = 0; i < this.cart.orderItems.length; i++) {
        arr.push(
          this.cart.orderItems[i].price * this.cart.orderItems[i].quantity,
        );
      }
      if (arr.length) {
        sum = arr.reduce(function(a, b) {
          return a + b;
        });
      }
      price = sum + this.membersPrice + this.basketPrice;
      //Halpern Akiva Academy
      if (
        this.organizationInfo.id === 635 &&
        this.organizationInfo.sMaximum < price
      ) {
        price = this.organizationInfo.sMaximum;
      }
      this.$store.state.finalOrder.totalPrice = price;
      return price;
    },
    processFeeNew() {
      // nee more work
      let fee = 0;
      // let price = 0;
      // let arr = [];
      // let sum = 0;
      // let fee = 0;
      // for (let i = 0; i < this.cart.orderItems.length; i++) {
      //   if (this.cart.orderItems[i].itemId !== 666) {
      //     arr.push(
      //       this.cart.orderItems[i].price * this.cart.orderItems[i].quantity
      //     );
      //   }
      // }
      // if (arr.length) {
      //   sum = arr.reduce(function (a, b) {
      //     return a + b;
      //   });
      // }
      // price = sum + this.membersPrice + this.basketPrice;
      // //Halpern Akiva Academy
      // if (
      //   this.organizationInfo.id === 635 &&
      //   this.organizationInfo.sMaximum < price
      // ) {
      //   price = this.organizationInfo.sMaximum;
      // }
      // // this.$store.state.finalOrder.totalPrice = price;
      // if (this.settings[0].creditCardPercent > 0) {
      //   fee = (price * this.settings[0].creditCardPercent) / 100;
      // }
      // this.$store.state.finalOrder.processFee = fee;
      // this.$store.state.finalOrder.perTransactionFee = this.settings[0].perTransactionFee;
      // let f_cart = this.cart.orderItems.filter((a) => a.itemId === 666 && a.price !== fee)
      // if(f_cart.length) {
      //   console.log("FEE Difference: new fee ", fee,"old fee ", f_cart[0].price)
      //   this.deleteOrderItem(f_cart[0],true)

      // }
      //   console.log("FEE ", fee)
      return fee;
    },
    feeText() {
      // let fee_total = Number(this.processFee) + Number(this.settings[0].perTransactionFee);
      // let fee_num = this.settings[0].symbol.concat(fee_total.toFixed(2))
      // let fee_text =  this.settings[0].feeText.concat(fee_num);
      // return fee_text;
      return null;
    },
    processFee() {
      // process fee when item in not cart
      let price = 0;
      let arr = [];
      let sum = 0;
      let fee = 0;
      for (let i = 0; i < this.cart.orderItems.length; i++) {
        arr.push(
          this.cart.orderItems[i].price * this.cart.orderItems[i].quantity,
        );
      }
      if (arr.length) {
        sum = arr.reduce(function(a, b) {
          return a + b;
        });
      }
      price = sum + this.membersPrice + this.basketPrice;
      //Halpern Akiva Academy
      if (
        this.organizationInfo.id === 635 &&
        this.organizationInfo.sMaximum < price
      ) {
        price = this.organizationInfo.sMaximum;
      }
      this.$store.state.finalOrder.totalPrice = price;
      if (this.settings[0].creditCardPercent > 0) {
        fee = (price * this.settings[0].creditCardPercent) / 100;
      }
      this.$store.state.finalOrder.processFee = fee;
      this.$store.state.finalOrder.perTransactionFee = this.settings[0].perTransactionFee;
      let f_fee = fee.toFixed(2);
      return JSON.parse(f_fee);
    },
    organizationInfo() {
      return this.$store.state.organizationInfo[0];
    },
    basketPrice() {
      let options = this.$store.state.shippingCustomOptions;
      let baskets = this.$store.state.cart.additionalBaskets;
      let local = this.$store.state.localDeliveryPricing;

      let p = 0;
      if (options.length) {
        let arr = [];
        for (var i = 0; i < baskets.length; i++) {
          const attArray = baskets[i].attributes
            ? JSON.parse(baskets[i].attributes)
            : [];
          const totalPriceAttribute =
            attArray.reduce((accumulator, current) => {
              const newValue = current.value ? current.price : 0;
              return accumulator + newValue;
            }, 0) || 0;

          let price = options.filter(
            (data) => baskets[i].shippingOptionId === data.id,
          );
          if (price.length) {
            //check if local price applies
            let l_price = local.filter(
              (d) => baskets[i].zip.trim() === d.zipCode.trim(),
            );
            if (l_price.length) {
              if (
                this.settings[0].organizationId === 371 &&
                baskets[i].shippingOptionId === 5
              ) {
                arr.push(15 + totalPriceAttribute);
              } else {
                arr.push(l_price[0].localDeliveryPrice + totalPriceAttribute);
              }
            } else {
              arr.push(price[0].price + totalPriceAttribute);
            }
          } else {
            arr.push(this.$store.state.organizationInfo[0].sSendoutprice);
          }
        }
        if (arr.length) {
          p = arr.reduce(function(a, b) {
            return a + b;
          });
        }
      } else if (local.length) {
        let arr = [];
        for (var i = 0; i < baskets.length; i++) {
          let price = local.filter(
            (data) => baskets[i].zip.trim() === data.zipCode.trim(),
          );
          if (price.length) {
            if (
              this.organizationInfo.id === 371 &&
              baskets[i].shippingOptionId === 5
            ) {
              arr.push(15);
            } else {
              arr.push(price[0].localDeliveryPrice);
            }
          } else {
            arr.push(this.$store.state.organizationInfo[0].sSendoutprice);
          }
        }
        if (arr.length) {
          p = arr.reduce(function(a, b) {
            return a + b;
          });
        }
      } else {
        p =
          baskets.length * this.$store.state.organizationInfo[0].sSendoutprice;
      }
      this.$store.state.finalOrder.basketPrice = p;
      return p;
    },
    comboPromotions() {
      return this.$store.state.comboPromotions;
    },
    promotions() {
      return this.$store.state.promotions;
    },
  },
  methods: {
    convertWithCommas,

    getItemCustomizations(item) {
      if (!item?.attributes) return [];
      return JSON.parse(item.attributes);
    },

    calculateAttributes(item) {
      const attArray = JSON.parse(item.attributes) || [];
      const addToPrice = attArray.reduce((accumulator, current) => {
        const newValue = current.value ? current.price : 0;
        return accumulator + newValue;
      }, 0);

      return addToPrice;
    },

    async onSelectedCustomBasket(item) {
      try {
        this.selCustomOptionBasketItem = item;
        this.additionalSelBasket.shippingOptionId = item.id;

        if (item.hasAttributes) {
          this.basketAttributes = [
            ...(await this.$store.dispatch("getAttributesById", {
              id: item.id,
            })),
          ];
          this.basketAttributesCheckBoxes = Array(
            this.basketAttributes.length,
          ).fill(false);

          for (let i = 0; i < this.basketAttributesCurrent.length; i++) {
            const auxAtt = this.basketAttributes.findIndex(
              (att) => att.id === this.basketAttributesCurrent[i].id,
            );

            if (auxAtt >= 0) {
              this.basketAttributes[auxAtt] = {
                ...this.basketAttributesCurrent[i],
              };
            }
          }
          this.basketAttributes.forEach((element, i) => {
            if (element.value) {
              this.basketAttributesCheckBoxes[i] = true;
            }
          });

          this.basketAttributesCurrent = [];
        }
      } catch (error) {
        console.error("ERROR ***", { error });
      }
    },

    //! Editing basket dialog
    editBasket: function(item) {
      // let person = item.recipient.split(" ");
      this.additionalSelBasketCopy = Object.assign({}, item);
      this.additionalSelBasket = { ...item };
      // this.additionalSelBasket.firstName1 = person[0];
      // this.additionalSelBasket.lastName1 = person[1];

      this.basketAttributesCurrent = item?.attributes
        ? JSON.parse(item.attributes)
        : [];

      const bask = this.$store.state.shippingCustomOptions.find(
        (ba) => ba.id === item?.shippingOptionId,
      );
      if (!!bask) this.onSelectedCustomBasket(bask);

      this.showDialog = true;
    },

    getShippingCustomOptions() {
      return this.$store.state.shippingCustomOptions;
    },

    getShippingDescription(id) {
      const description =
        this.$store.state.shippingCustomOptions.find((item) => item.id === id)
          ?.description || "";

      return description;
    },

    addFeeToCart() {
      if (this.$store.state.finalOrder.totalDiscountedPrice > 0) {
        if (this.settings[0].feeActive) {
          let fees =
            this.$store.state.finalOrder.processFee +
            this.$store.state.finalOrder.perTransactionFee;
          this.updateUpsellFee(fees).then();
        }
      } else {
        if (this.settings[0].feeActive) {
          let fees =
            this.$store.state.finalOrder.processFee +
            this.$store.state.finalOrder.perTransactionFee;
          this.updateUpsellFee(fees).then();
        }
      }
    },
    onCancel: function() {
      this.showPromptFees = false;
    },
    showFeePrompt: function() {
      let cart = this.cart.orderItems;

      let f_cart = cart.filter((a) => a.itemId === 666);
      if (
        this.settings[0].feeActive &&
        !this.settings[0].feeRequired &&
        !f_cart.length
      ) {
        this.showPromptFees = true;
        // console.log(
        //   "cart order items",
        //   this.$store.state.cart.orderItems,
        //   f_cart.length
        // );
      } else {
        console.warn("Donate Fee Dialog not active,or Already is in the cart");
      }
      console.warn("f_cart.length", f_cart.length, cart);
    },
    async updateUpsellFee(fees) {
      try {
        let obj = {
          itemId: 666,
          price: JSON.parse(fees),
          quantity: 1,
          description: this.settings[0].feeDesc,
          shipTo: "",
          message: "",
        };
        await this.$store.dispatch("updateUpsell", { data: obj, param: "add" });
      } catch (error) {
        console.error(error);
        showErrorAlert(true);
      }
    },
    addServiceFeeDonation(fee) {
      if (fee) {
        let total = this.processFee + this.settings[0].perTransactionFee;

        this.updateUpsellFee(total.toFixed(2)).then();
      }
    },
    getPromoPeople: function(item) {
      let obj = [];
      for (var i = 0; i < this.comboPromotions.length; i++) {
        if (this.comboPromotions[i].promo.itemId === item.itemId) {
          obj = this.comboPromotions[i].members;
        }
      }
      return obj;
    },

    closeBasket: function(item) {
      // item.recipient = this.additionalSelBasketCopy.recipient;
      // item.address = this.additionalSelBasketCopy.address;
      // item.city = this.additionalSelBasketCopy.city;
      // item.zip = this.additionalSelBasketCopy.zip;
      // item.message = this.additionalSelBasketCopy.message;
      this.showDialog = false;
    },
    saveBasket: async function(item) {
      if (!item.recipient || !item.address || !item.city || !item.zip) {
        this.$store.commit("showToast", {
          message: "Recipient, Address, City, Postal Code cannot be empty!",
          position: "bottom",
          type: "error",
        });
      } else {
        let shipping_obj = {
          message: item.message,
          recipient: item.recipient.trim(),
          address: item.address,
          address2: item.address2,
          city: item.city,
          zip: item.zip,
          shippingOptionId: item.shippingOptionId,
          email: item.email,
          phoneNumber: item.phoneNumber,
          glutenFree: item.glutenFree,
          state: item.state,
          shippingItemGuid: item.shippingItemGuid,
          Attributes: JSON.stringify(this.basketAttributes),
        };
        await this.$store.dispatch("updateShipping", {
          data: shipping_obj,
          param: "add",
        });
        this.showDialog = false;
      }
      // this.$store.dispatch("updateUpsell", {data:obj,param:'add'});
      // this.$store.dispatch("getOrderItems");
    },
    openPrompt: function(item) {
      this.showPrompt = true;
      this.selItem = item;
    },
    onCancel: function() {
      this.showPrompt = false;
      this.selItem = {};
    },
    async deleteBasket(item) {
      try {
        let index = this.$store.state.cart.additionalBaskets.findIndex(
          (a) => a.shippingItemGuid === item.shippingItemGuid,
        );
        this.$store.state.cart.additionalBaskets.splice(index, 1);
        let shipping_obj = {
          message: item.message,
          recipient: item.recipient,
          address: item.address,
          address2: item.address2,
          city: item.city,
          zip: item.zip,
          shippingOptionId: item.shippingOptionId,
          email: item.email,
          phoneNumber: item.phoneNumber,
          glutenFree: item.glutenFree,
          state: item.state,
          shippingItemGuid: item.shippingItemGuid,
          Attributes: "",
        };
        await this.$store.dispatch("getTotal");
        await this.$store.dispatch("updateShipping", {
          data: shipping_obj,
          param: "delete",
        });
        let obj = {
          itemId: 2,
          price: 0,
          quantity: item.Qt,
          description: "Shipping Gift Basket to",
          shipTo: item.recipient,
          message: item.message,
          Attributes: "",
        };
        await this.$store.dispatch("updateUpsell", {
          data: obj,
          param: "delete",
        });

        this.showPrompt = false;
      } catch (error) {
        console.error("error deleting", { error });

        console.error(error);
        showErrorAlert(true);
      }
    },
    async deleteMember(item) {
      let index_main = this.$store.state.list.findIndex(
        (a) => a.id === item.id,
      );
      let index_cart = this.$store.state.cart.list.findIndex(
        (a) => a.id === item.id,
      );
      this.$store.state.list[index_main].selected = false;
      this.$store.state.cart.list[index_cart].selected = false;
      this.$store.state.cart.list.splice(index_cart, 1);

      await this.$store.dispatch("updateData", {
        data: [
          {
            tempcode: this.$store.state.tempCode,
            receiver: this.$store.state.list[index_main].id,
          },
        ],
        param: "delete",
      });
      await this.$store.dispatch("getTotal");
      await this.$store.dispatch("getOrderItems");
    },

    async deleteOrderItem(item, followup) {
      try {
        await this.$store.dispatch("updateUpsell", {
          data: item,
          param: "delete",
          people: this.getPromoPeople(item),
        });
        for (let i = 0; i < this.$store.state.cart.upsell.length; i++) {
          if (item.description === this.$store.state.cart.upsell[i].Label) {
            this.$store.state.cart.upsell[i].Value = 0;
            this.$store.state.cart.upsell[i].Qt = 0;
          }
        }

        let new_ids = []; // new ids  that still in selected promos
        let old_ids = []; // deleted ids that were in promotion
        for (let i = 0; i < this.comboPromotions.length; i++) {
          if (item.itemId === this.comboPromotions[i].promo.itemId) {
            old_ids = this.comboPromotions[i].ids;
            this.comboPromotions.splice(i, 1);
          } else {
            for (let j = 0; j < this.comboPromotions[i].ids.length; j++) {
              if (new_ids.indexOf(this.comboPromotions[i].ids[j]) === -1) {
                new_ids.push(this.comboPromotions[i].ids[j]);
              }
            }
          }
        }
        //  updating my mishloah manot list
        let list = this.$store.state.list;
        for (let i = 0; i < list.length; i++) {
          if (!list[i].paid) {
            if (
              old_ids.indexOf(list[i].id) > -1 &&
              new_ids.indexOf(list[i].id) === -1
            ) {
              list[i].selected = false;
            }
          }
        }
        for (let i = 0; i < this.promotions.length; i++) {
          if (item.itemId === this.promotions[i].itemId) {
            this.promotions[i].value = false;
          }
        }
        this.saveList().then();
      } catch (error) {
        console.error(error);
        showErrorAlert(true);
      }
    },
    async saveList() {
      let new_list = this.$store.state.list;
      //  updating table in api with members
      let checked_list = new_list.filter((a) => a.selected && !a.paid);
      let checked_arr = [];
      for (let i = 0; i < checked_list.length; i++) {
        let item = {};
        item.tempcode = this.$store.state.tempCode;
        item.receiver = checked_list[i].id;
        if (
          !this.$store.state.shippingCustomOptions.length ||
          this.customOptions.noShipCustom.indexOf(this.organizationInfo.id) > -1
        ) {
          item.price = checked_list[i].price;
        } else {
          let ship = this.$store.state.shippingCustomOptions.filter(
            (a) => a.description === checked_list[i].basketType,
          );
          if (ship.length) {
            item.price = ship[0].price;
            item.customPrice = ship[0].price;
          }
        }
        checked_arr.push(item);
      }
      // api call
      if (checked_arr.length) {
        await this.$store.dispatch("updateData", {
          data: checked_arr,
          param: "add",
        });
        this.$store.state.checked_arr = checked_arr;
      }
      if (!checked_arr.length) {
        await this.$store.dispatch("updateData", { data: [], param: "clear" });
      }
      await this.$store.dispatch("getTotal");
      await this.$store.dispatch("getOrderItems");
    },
    async deleteDonation(item, label) {
      try {
        if (label === "donation") {
          let obj = {
            description: "Donation To Charity - " + item.description,
            itemId: item.itemId,
            message: "",
            price: item.Price,
            quantity: 0,
            shipTo: "",
          };
          let index = this.$store.state.cart.donations.indexOf({
            charityId: item.charityId,
          });
          this.$store.state.cart.donations.splice(index, 1);
          await this.$store.dispatch("updateUpsell", {
            data: obj,
            param: "delete",
          });
        } else if (label === "additional") {
          let obj = {
            description: item.Label,
            itemId: item.ID,
            message: "",
            price: item.Price,
            quantity: item.Qt,
            shipTo: "",
          };
          await this.$store.dispatch("updateUpsell", {
            data: obj,
            param: "delete",
          });
          let index = this.$store.state.cart.additional.indexOf({
            Label: item.Label,
          });
          this.$store.state.cart.additional.splice(index, 1);
        } else if (label === "upsell") {
          let obj = {
            description: item.Label,
            itemId: 5,
            message: "",
            price: item.Price,
            quantity: item.Qt,
            shipTo: "",
          };
          await this.$store.dispatch("updateUpsell", {
            data: obj,
            param: "delete",
          });
          let index = this.$store.state.cart.upsell.indexOf({ ID: item.ID });
          this.$store.state.cart.upsell.splice(index, 1);
          await this.$store.dispatch("getTotal");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert(true);
      }
    },
  },
  created() {},
  async mounted() {
    await this.$store.dispatch("getTotal");
    await this.$store.dispatch("getOrderItems");
    await this.$store.dispatch("getOrderItems");
  },
};
</script>
<style scoped>
.sidebar .sidebar__box {
  margin-bottom: 0;
}
.sidebar .sidebar__foot {
  margin-top: 27px;
}
.member-wrap {
  margin: 0 10px;
  border-right: 1px solid #dfdfdf;
  border-left: 1px solid #dfdfdf;
}
.green-border {
  border-bottom: 2px solid #8ef87a;
}
.sidebar .sidebar__box__pink {
  background-color: var(--app-color-primary);
}
.trunculate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
.fa-times {
  color: red !important;
  font-size: 15px;
}
.fa-edit {
  color: #ff7600 !important;
  font-size: 15px;
}
.w-70 {
  width: 50px;
}
table td {
  overflow-wrap: break-word;
}
.table tbody + tbody {
  border-top: 0;
}
.basket-message label {
  margin-bottom: 0;
  font-size: 11px;
  font-weight: 600;
  color: #878787;
  display: block;
}
.basket-message {
  font-size: 11px;
  padding: 0.2rem 0.75rem;
}
.b-t-pink {
  background: #fff5f7;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 12px;
}
.md-dialog /deep/.md-dialog-container {
  max-width: 768px;
}
.md-dialog-content {
  padding: 0 24px 24px;
  flex: 1;
  flex-basis: auto;
  overflow: auto;
  position: relative;
  /* max-height: 380px; */
  /* max-height: 73vh; */
  height: 500px;
}
.btn-grey {
  text-transform: capitalize !important;
  min-width: 135px !important;
  min-height: 36px;
  padding: 0 8px !important;
}
.md-dialog-title {
  margin-bottom: 15px;
  padding: 1em;
  background: #ededed;
  border-bottom: 1px solid #dcdcdc;
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
  max-height: 250px;
  overflow: auto;
}
.btn-grey-small {
  text-transform: capitalize !important;
  min-width: 135px !important;
  min-height: 36px;
  padding: 0 8px !important;
}
.total-wrap {
  border-top: 1px solid #ededed;
  padding-top: 1em;
}
.sidebar a {
  color: #fff !important;
}
.table .table-mobile td,
.table th {
  padding: 0.75rem 0.25rem;
  font-size: 0.9em;
}
.pink {
  color: var(--app-color-primary) !important;
  font-size: 14px !important;
}
.fee {
  padding-bottom: 0.5em;
}
/* /deep/.md-radio.md-theme-default.md-checked .md-radio-container {
  border-color: var(--app-color-primary);
}
/deep/.md-radio.md-theme-default.md-checked .md-radio-container:after {
  background-color: var(--app-color-primary);
} */
.md-dialog /deep/ .md-dialog-title {
  margin-bottom: 20px;
  padding: 12px 24px 12px;
  background: var(--app-color-primary);
  color: white;
}

.item-recipient-container {
  display: flex;
  justify-content: space-between;
}

.custom-basket {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
}
.selected-custom-basket {
  border-width: 2px;
  border-style: solid;
  border-color: var(--app-color-primary);
  border-radius: 5px;
}
.personalization-p {
  display: flex;
  justify-content: center;
  font-size: 26px;
  font-weight: 600;
  color: var(--app-color-primary);
}
</style>
